import * as React from 'react';
import { IPosition, ILogistics } from '@nkr/models/index';
import { TableWrapper } from './styles';
import { ButtonGroup, Button } from 'react-bootstrap';
import LogisticsViewContent from '@nkr/views/swap-management/swaps/swap-list/logistics/view-content';

interface IProps {
    list: IPosition[],
    logistics: ILogistics,
    onGetLogistics: (swap: IPosition) => Promise<any>,
}

interface IState {
    showLogistics: boolean
}

class TransplantPickup extends React.Component<IProps, IState> {
    readonly state: IState = {
        showLogistics: false
    }

    handleViewLogistics = (swap: IPosition) => {
        if (this.state.showLogistics == false) {
            this.props.onGetLogistics(swap).then(() => {
                this.setState({
                    showLogistics: true
                });
            });
        } else {
            if (this.props.logistics.donorId != swap.donor.id) {
                this.props.onGetLogistics(swap).then(() => {
                    this.setState({
                        showLogistics: true
                    });
                });
            } else {
                this.setState({
                    showLogistics: false
                });
            }
        }
    }

    handleShowMap = (mapLink: string) => {
        window.open(mapLink);
    }

    handleShowGps = (gpsLink: string) => {
        window.open(gpsLink);
    }

    render = () => {
        return (
            <>
                <TableWrapper className='table table-condensed table-striped table-bordered'>
                    <thead>
                        <tr>
                            <th rowSpan={2}>Donor</th>
                            <th colSpan={2}>Recipient</th>
                            <th rowSpan={2}>Pickup Date/Time</th>
                            <th rowSpan={2}>Courier</th>
                            <th rowSpan={2}>Logistics / GPS</th>
                        </tr>
                        <tr>
                            <th>Center</th>
                            <th>Alias</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.list.map((item, index) =>
                            <tr key={'tp-' + index}>
                                <td>{item.donor.alias}</td>
                                <td>{item.recipient.center.alias}</td>
                                <td>{item.recipient.alias}</td>
                                <td>{item.donor.logistics.kidneyPickupDateTime}</td>
                                <td>{item.recipient.logisticsProviderName}</td>
                                <td>
                                    <ButtonGroup>
                                        <Button bsSize='xs' style={{ minWidth: 25, padding: '1px 3px', fontSize: 10 }} onClick={() => this.handleViewLogistics(item)}>L</Button>
                                        {item.donor.logistics.mapLink && (
                                            <Button bsSize='xs' bsStyle={'default'} style={{ minWidth: 25, padding: '1px 3px', fontSize: 10 }} onClick={() => this.handleShowMap(item.donor.logistics.mapLink)}>M</Button>
                                        )}
                                        {item.gpsAutomation != null && item.gpsAutomation.gpsLink != '' && (
                                            <Button bsSize='xs' style={{ minWidth: 25, padding: '1px 3px', fontSize: 10 }} onClick={() => this.handleShowGps(item.gpsAutomation.gpsLink)}>G{item.gpsAutomation.gpsNumber}</Button>
                                        )}
                                    </ButtonGroup>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </TableWrapper>

                {this.state.showLogistics && (
                    <div style={{ width: '90%', marginLeft: 'auto', marginRight: 'auto', marginTop: 10 }}>
                        <LogisticsViewContent
                            data={this.props.logistics}
                            fontSize={12}
                        />
                    </div>
                )}
            </>
        );
    }
}

export default TransplantPickup;